import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=52177dae&scoped=true&"
import script from "./editAddress.vue?vue&type=script&lang=js&"
export * from "./editAddress.vue?vue&type=script&lang=js&"
import style0 from "./editAddress.vue?vue&type=style&index=0&id=52177dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52177dae",
  null
  
)

export default component.exports